import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { setTemplate } from '../actions';

import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { FlatButton, Dialog } from 'material-ui';

import WidgetEdit from './WidgetEdit';
import WidgetPickerStandalone from '../../widget-picker/containers/WidgetPickerStandalone';
import AllWidgetsOverview from '../../widget-picker/containers/AllWidgetsOverview';
import { Scrollbars } from 'react-custom-scrollbars';

function Editor({
    allowChangeWidget,
    widgetId,
    tab,
    widgetProps,
    template,
    openEditWidget,
    openPicker,
    mainAction,
    setTemplate,
}) {
    return widgetId ? (
        <WidgetEdit
            widgetId={widgetId}
            widgetProps={widgetProps}
            template={template}
            tab={tab}
            allowChangeWidget={allowChangeWidget}
            onChangeWidgetRequest={openPicker}
            mainAction={mainAction}
        />
    ) : (
        <Scrollbars>
            <div style={{ padding: 20 }}>
                <AllWidgetsOverview
                    template={template}
                    onClick={(e, widget, template) => {
                        openEditWidget(widget.id, widget.props, template);
                    }}
                />
            </div>
        </Scrollbars>
    );
}

const EditorEnhanced = compose(
    connect(
        () => ({}),
        { setTemplate },
    ),
    withStateHandlers(
        ({ template, widgetProps, widgetId }) => ({
            widgetId,
            widgetProps,
            template,
        }),
        {
            openEditWidget: () => (widgetId, widgetProps, template) => {
                return { widgetId, widgetProps, template };
            },
            openPicker: () => () => ({
                widgetId: null,
                widgetProps: null,
            }),
            setTemplate: () => template => {
                return { template };
            },
        },
    ),
    lifecycle({
        componentDidMount() {
            if (this.props.widgetId) {
                this.props.openEditWidget(this.props.widgetId, this.props.widgetProps, this.props.template);
            }

            if (this.props.template) {
                this.props.setTemplate(this.props.template);
            }
        },
        componentWillReceiveProps(nextProps) {
            if (nextProps.widgetId != this.props.widgetId) {
                this.props.openEditWidget(nextProps.widgetId, nextProps.widgetProps, nextProps.template);
            }

            if (this.props.template != nextProps.template) {
                console.log('DO CHANGE TEMPLATE', nextProps.template);
                this.props.setTemplate(nextProps.template);
            }
        },
    }),
)(Editor);

const defActions = ({ onRequestClose }) => [<FlatButton key="close" label="close" primary onClick={onRequestClose} />];

const EditorDialogue = ({ title, actions, open = false, modal, onRequestClose, ...props }) => (
    <MuiThemeProvider muiTheme={getMuiTheme(darkBaseTheme)}>
        <Dialog
            contentStyle={{
                minWidth: '1200px',
                maxWidth: '1600px',
                width: '90vh',
                height: '80vh',
                minHeight: '80vh',
            }}
            bodyStyle={{ padding: 0 }}
            title={title}
            actions={actions}
            modal={modal}
            open={open}
            autoDetectWindowHeight
            onRequestClose={onRequestClose}
        >
            <EditorEnhanced {...props} />
        </Dialog>
    </MuiThemeProvider>
);

export default EditorEnhanced;

export { EditorDialogue };



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/Editor.js
 **/